<style>
</style>

<template>
<div id="auth--view">
  <v-container grid-list-xs>
    <v-col xs="12" class="text-center">
      <!-- <div class="headline primary--text">{{ $t('Otevření aplikace') }}</div> -->
    </v-col>
    <v-col xs="12" grey--textclass="text-center" v-if="!validAuthorization">
      <div>{{ $t('Nepodařilo se úspěšně otevřít aplikaci ') }}<span class="font-weight-bold">{{ $t(appName) }}</span>{{'. '}}</div>
      <div>{{ $t('Můžete opakovat přihlášení nebo pokračovat jako neregistrovaný uživatel ') }}
        <router-link to="home">{{ $t('zde') }}</router-link>{{ '.' }}
      </div>
    </v-col>
  </v-container>
</div>
</template>

<script>
import StorageMixin from '@/mixins/storage-mixin.js'
const kzona = require('@/oauth2/kzona.json')
const eshop = require('@/oauth2/eshop.json')

export default {
  name: 'AuthPage',
  data() {
    return {
      validAuthorization: true
    }
  },
  mixins: [StorageMixin],
  mounted() {
    var hasGuestToken = this.hasAccessToken && this.isGuest
    const oauth2 = hasGuestToken ? kzona : eshop
    if (this.$route.query.code === 'NOSIGN') {
      this.setRegistered(false)
      this.$router.push({
        name: 'home'
      }).catch(console.log)
    } else {
      this.$oauth2.handleAuthQuery(oauth2, this.$route.query).then(() => {
        this.$router.push({
          name: 'home'
        }).catch(console.log)
      }).catch(error => {
        this.validAuthorization = false
        this.setRegistered(false)
        console.log(error.message)
      })
    }
  },
  computed: {
    appName: {
      get() {
        const oauth2 = !this.isRegistered ? eshop : kzona
        return oauth2.name
      }
    }
  }
}
</script>
